export enum BoundType {
  /* 0 */ Undefined,
  /* 1 */ Visible,
  /* 2 */ HiddenLeft,
  /* 3 */ ClippedLeft,
  /* 4 */ ClippedBoth,
  /* 5 */ ClippedRight,
  /* 6 */ HiddenRight,
}

export enum RangeType {
  OL,
  IN,
  OR,
}

const key = (start: RangeType, end: RangeType): string => `${start}:${end}`;

const BoundTypeDictionary = {
  [key(RangeType.OL, RangeType.OL)]: BoundType.HiddenLeft,

  [key(RangeType.IN, RangeType.OL)]: BoundType.ClippedLeft,
  [key(RangeType.OL, RangeType.IN)]: BoundType.ClippedLeft,

  [key(RangeType.OL, RangeType.OR)]: BoundType.ClippedBoth,
  [key(RangeType.OR, RangeType.OL)]: BoundType.ClippedBoth,

  [key(RangeType.IN, RangeType.IN)]: BoundType.Visible,

  [key(RangeType.IN, RangeType.OR)]: BoundType.ClippedRight,
  [key(RangeType.OR, RangeType.IN)]: BoundType.ClippedRight,

  [key(RangeType.OR, RangeType.OR)]: BoundType.HiddenRight,
};

export const getRangeType = (boundStart: number, boundEnd: number, position: number): RangeType => {
  if (position < boundStart) return RangeType.OL;
  if (position > boundEnd) return RangeType.OR;
  return RangeType.IN;
};

export const getBoundType = (boundStart: number, boundEnd: number, itemStart: number, itemEnd: number): BoundType => {
  const startRangeType = getRangeType(boundStart, boundEnd, itemStart);
  const endRangeType = getRangeType(boundStart, boundEnd, itemEnd);

  const boundTypeIndexKey = key(startRangeType, endRangeType);
  return BoundTypeDictionary[boundTypeIndexKey] ?? BoundType.Undefined;
};
